import { useState, useRef, useEffect } from "react";
import { useSingleton } from "../../hooks/use-singleton";
import { useApi } from "../../hooks/use-api";
import { API_GET_MCQ_TNPSC, API_MEDIUM_TNPSC } from "../../utils/api-routes";
import {
  API_MCQ_SUBJECTS,
  API_MCQ_CHAPTERS,
  API_EVALUATE_TNPSC,
  API_DESCRIPTIVE,
} from "../../utils/api-routes";
import { apiStudentStudys } from "../../utils/api-routes";
import { useSearchParams } from "react-router-dom";

export const useHandler = () => {
  const { user, mail, medium } = useSingleton();
  const { get, post } = useApi();
  const [searchParams] = useSearchParams();
  const subject = searchParams.get("subject");
  const chapter = searchParams.get("chapter");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(
    subject ? subject : "",
  );
  const [selectedChapter, setSelectedChapter] = useState(
    chapter ? chapter : "",
  );
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [questionDetails, setQuestionDetails] = useState([]);
  const [markDetails, setMarkDetails] = useState({});
  const [showMarks, setShowMarks] = useState(false);
  const [isQuizActive, setIsQuizActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectChapters, setSelectedChapters] = useState(
    chapter ? [chapter] : [],
  );
  const dropdownWrapperRef = useRef(null);
  const [selectedWeightage, setSelectedWeightage] = useState("");
  const [selectedQuestionCount, setSelectedQuestionCount] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [selectedMedium, setSelectedMedium] = useState("");
  console.log(selectedWeightage, "selectedWeightage");
  const [questions, setQuestions] = useState([]);
  const [mediums, setMediums] = useState([]);
  const [currentQIndex, setCurrentQIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [classdetails, setClassDetails] = useState({});

  const mediumRef = useRef(null);
  const subjectRef = useRef(null);
  const chapterRef = useRef(null);

  const [panelOpen, setPanelOpen] = useState(true); // Start open

  // const isStartEnabled = !!selectedSubject && !!selectedChapter;

  //   const isStartEnabled =
  //   !!selectedSubject && selectChapters.length > 0;

  const isStartEnabled =
    !!selectedSubject &&
    selectChapters.length > 0 &&
    !!selectedWeightage &&
    !!selectedQuestionCount;

  const getUserStudiesDetails = async () => {
    try {
      const res = await get(apiStudentStudys(mail));
      if (res) {
        setClassDetails(res?.data);
        const payload = {
          board: res?.data?.data?.board,
          clas: res?.data?.data?.class,
        };
        getMediumDetails(payload);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      console.log("Error on getting user studiesdetails", e);
    }
  };

  const getMediumDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_MEDIUM_TNPSC, payload);
      if (res) {
        setMediums(res?.data?.mediums);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getSubjectDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_MCQ_SUBJECTS, payload);
      if (res) {
        setSubjects(res?.data?.subjects);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getChapterDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_MCQ_CHAPTERS, payload);
      if (res) {
        setChapters(res?.data?.chapters);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting chapeter details", e);
    }
  };

  const getMcqdetails = async () => {
    try {
      const payload = {
        mail,
        board: user?.data?.board,
        clas: user?.data?.class,
        subject: selectedSubject,
        // chapter:selectedChapter,
        chapter: selectChapters,
      };
      const res = await post(API_GET_MCQ_TNPSC, payload);
      if (res) {
        setQuestionDetails(res?.data);
      }
    } catch (e) {
      console.log("getting error from get mcq details", e);
    }
  };

  useEffect(() => {
    getUserStudiesDetails();
  }, []);

  useEffect(() => {
    if (!medium || !classdetails?.data?.class) return;
    const payload = {
      board: classdetails?.data?.board,
      clas: classdetails?.data?.class,
      medium: medium,
    };

    getSubjectDetails(payload);
  }, [medium, classdetails?.data?.class]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!dropdownWrapperRef.current?.contains(e.target)) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // const onStartQuiz = () => getMcqdetails();
  const onStartQuiz = async () => {
    try {
      setIsLoading(true);

      const payload = {
        mail: user?.data?.email,
        board: user?.data?.board,
        clas: user?.data?.class,
        subject: selectedSubject,
        chapter: selectChapters.join(", "),
        marks: parseInt(selectedWeightage),
        count: Number(selectedQuestionCount),
      };

      console.log("Descriptive Payload:", payload);

      const response = await post(API_DESCRIPTIVE, payload);

      console.log("Descriptive Response:", response);

      // You can store response in state if needed
      setQuestions(response?.data || []);
      setIsQuizActive(true);
    } catch (error) {
      console.error("Descriptive API Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedSubject || !user?.data?.class) return;

    const payload = {
      board: user?.data?.board,
      clas: user?.data?.class,
      subject: selectedSubject,
    };
    getChapterDetails(payload);
  }, [selectedSubject]);

  const normalizeQuestions = (apiData = []) =>
    apiData.map((q) => ({
      question: q["QUESTION"],
      options: [q["OPTION A"], q["OPTION B"], q["OPTION C"], q["OPTION D"]],
      answer: q["ANSWER"],
      questionId: q["QUESTION_ID"],
    }));

  const currentQuestion = questions[currentQIndex];

  useEffect(() => {
    if (questionDetails?.length) {
      const formatted = normalizeQuestions(questionDetails);
      setQuestions(formatted);
    }
  }, [questionDetails]);

  const handleOptionSelect = (index) => {
    // ❌ if already answered, don't allow change
    if (selectedAnswers[currentQIndex] !== undefined) return;
    setSelectedAnswers((prev) => ({
      ...prev,
      [currentQIndex]: index,
    }));
  };

  const selectedOption = selectedAnswers[currentQIndex];

  const handleNext = () => {
    if (currentQIndex < questions.length - 1) {
      setCurrentQIndex((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQIndex > 0) {
      setCurrentQIndex((prev) => prev - 1);
    }
  };

  const buildSubmitPayload = () => {
    return questions
      .map((q, index) => {
        const selectedIndex = selectedAnswers[index];

        // // Skip unattempted questions
        // if (selectedIndex === undefined) return null;

        return {
          QUESTION: q.question,
          ANSWER: selectedIndex !== undefined ? q.options[selectedIndex] : "",
          CHAPTER: selectedChapter,
          QUESTION_ID: q.questionId || "",
        };
      })
      .filter(Boolean); // remove nulls
  };

  const onSubmitQuiz = async () => {
    const payload = buildSubmitPayload();
    const formattedPayload = {
      board: user?.data?.board,
      clas: user?.data?.class,
      subject: selectedSubject,
      mail,
      answers: payload,
    };
    setShowMarks(true);
    try {
      const res = await post(API_EVALUATE_TNPSC, formattedPayload);
      if (res) {
        console.log(res?.data, "res");
        setMarkDetails(res?.data);
        localStorage.setItem("marks", res?.data);
      }
    } catch (e) {
      console.log("Error on submitquiz details", e);
    }
  };

  const getQuestionCountOptions = () => {
    if (selectedWeightage === "2 marks") {
      return [2, 4, 6, 8, 10]; // max 10
    }

    if (selectedWeightage === "3 marks") {
      return [2, 4, 6, 8, 10]; // max 10
    }

    if (selectedWeightage === "5 marks") {
      return [1, 2, 3, 4]; // max 4
    }

    if (selectedWeightage === "8 marks") {
      return [1, 2, 3]; // max 3
    }

    return [];
  };

  return {
    user,
    subjectRef,
    chapterRef,
    openDropdown,
    selectedChapter,
    selectedSubject,
    panelOpen,
    subjects,
    chapters,
    isStartEnabled,
    questionDetails,
    currentQuestion,
    selectedOption,
    questions,
    currentQIndex,
    markDetails,
    showMarks,
    isQuizActive,
    isLoading,
    selectChapters,
    mediums,
    selectedMedium,
    mediumRef,
    setSelectedChapters,
    setPanelOpen,
    setOpenDropdown,
    setSelectedChapter,
    setSelectedSubject,
    onStartQuiz,
    handleNext,
    handlePrevious,
    handleOptionSelect,
    onSubmitQuiz,
    // onRetakeQuiz,
    setIsQuizActive,
    // getQuizDuration,
    selectedLanguage,
    setSelectedLanguage,
    selectedWeightage,
    setSelectedWeightage,
    selectedQuestionCount,
    setSelectedQuestionCount,
    getQuestionCountOptions,
    setMediums,
    setSelectedMedium,
    dropdownWrapperRef,
  };
};
